import React from 'react';
import EditButton from '../../ui/EditButton';

const iconMap = {
  Website: '🌐',
  'WhatsApp Group': '💬',
  'Facebook Page': '📘',
  Instagram: '📸',
  Twitter: '🐦',
  Discord: '🎮',
  YouTube: '▶️',
  Linktree: '🌲',
  Other: '🔗',
};

export default function PublicLinksCard({ links = [], onEdit, isAdmin}) {
  const hasLinks = Array.isArray(links) && links.length > 0;

  return (
    <div className="team-card">
      <div className="card-header-with-icon">
        <span className="card-title">Public Links</span>
        {isAdmin && (<EditButton section="publicLinks" onEdit={onEdit} />)}
      </div>
      <div className="card-body">
        {hasLinks ? (
          <ul className="link-list">
            {links.map((link, i) => (
              <li key={i}>
                <span className="emoji">{iconMap[link.type] || '🔗'}</span>{' '}
                <a href={link.url} target="_blank" rel="noopener noreferrer">
                  {link.label || link.url}
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-muted">No links added yet — share your socials or key links here.</p>
        )}
      </div>
    </div>
  );
}
